import React, { useEffect, useState } from "react";
import Header from "../Headers/Header";
import DataPrivacy from "./DataPrivacy";
import ReactHtmlParser from "react-html-parser";
import parse from "html-react-parser";
import Swal from "sweetalert2";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import "./_TermsAndCondition.scss";
import "./_textFormat.scss";

import { getTermsPrivacy } from "../../api";

const SingelPrivacy = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const controller = new AbortController();

    setLoading(true);
    getTermsPrivacy(controller)
      .then((res) => {
        const file = res.data.data.find((item) => item.file === "PRIVACY");

        setData(file.html.replaceAll("className", "class"));
      })
      .catch((err) => {
        Swal.fire({
          title: "Error!",
          text: err.response.data.message,
          icon: "error",
          confirmButtonText: "Close",
          confirmButtonColor: "#55428A",
        });
      })
      .finally(() => setLoading(false));

    return () => controller.abort();
  }, []);

  return (
    <>
      {/* <Header /> */}
      <div className="satellite-bg">
        <div className="container terms-question">
          <div className="white-box-container terms-question terms-privacy-container">
            <div
              className="tnc-single custom-scrollbar"
              style={{ scrollBehavior: "smooth" }}
            >
              <div>
                <div>
                  <h4>Personal Data Privacy Policy</h4>
                  <div>
                    {loading ? (
                      <Skeleton count={30} />
                    ) : data ? (
                      // ReactHtmlParser(data)
                      parse(data)
                    ) : (
                      ""
                    )}
                    {/* <DataPrivacy /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SingelPrivacy;
